/* eslint-disable jsx-a11y/img-redundant-alt */
import { useTranslation } from "react-i18next";
import image1 from "./image/gife/gife.png";
import image2 from "./image/gife/photo2.jpg";
import image3 from "./image/gife/iphone.png";
import image4 from "./image/gife/photo4.jpg";
const Register = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <div className="Text-Top">
          <h1 className="Text-About">{t("GifeA")}</h1>
          <div>
            <img src={image1} alt="image" className="image" />
          </div>
          <h1 className="Text-About">{t("Gifeb")}</h1>
          <div>
            <img src={image2} alt="image" className="image" />
          </div>
          <h1 className="Text-About">{t("Gifec")}</h1>
          <div>
            <img src={image4} alt="image" className="image" />
          </div>
          <h1 className="Text-About">{t("Gifed")}</h1>
          <div>
            <img src={image3} alt="image" className="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
